
export default function BackToTop() {
  return null;
}